import { useTranslation } from "react-i18next";
import multiMode from "./filterBaseMulti";

const rawItems = [
	{
		key: 0,
		value: 1,
	},
	{
		key: 1,
		value: 2,
	},
	{
		key: 2,
		value: 4,
	},
	{
		key: 4,
		value: 16,
	},
	{
		key: 5,
		value: 32,
	},
	{
		key: 6,
		value: 64,
	},
];

export { rawItems };

export const compute = {
	apiToValue: (api) => {
		const final = [];
		let temp = api;

		const array = rawItems.map(({ value }) => value).reverse();

		array.forEach((bite) => {
			if (temp - bite >= 0) {
				final.push(bite);
				temp -= bite;
			}
		});
		return final.reverse();
	},
	valueToApi: (value) => {
		if (!value) return 0;
		const current = value.reduce((acc, value) => acc + value, 0);
		return current;
	},
};

const useFilterActivityType = ({ initial = 0, allCheckedInitial = false }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const items = rawItems.map((item) => {
		return {
			...item,
			content: t(`filtersAndSelectors:activityType.${item.key}`),
			text: t(`filtersAndSelectors:activityType.${item.key}`),
			tooltip:
				item.key >= 6
					? t(`filtersAndSelectors:activityType.comment.${item.key}`)
					: null,
			meta: {
				url: String(item.value),
			},
		};
	});

	const allCheckedInitialValue = items
		.map((item) => item.value)
		.reduce((acc, value) => acc + value, 0);

	return {
		items,
		compute,
		...multiMode({
			items,
			compute,
			initial: allCheckedInitial
				? compute.apiToValue(allCheckedInitialValue).join("-")
				: compute.apiToValue(initial).join("-"),
		}),
	};
};

export default useFilterActivityType;
